import { render, staticRenderFns } from "./CardDistribuicao.vue?vue&type=template&id=45bca6a5&scoped=true&"
import script from "./CardDistribuicao.vue?vue&type=script&lang=js&"
export * from "./CardDistribuicao.vue?vue&type=script&lang=js&"
import style0 from "./CardDistribuicao.vue?vue&type=style&index=0&id=45bca6a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bca6a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
